// src/context/InterestContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";

const InterestContext = createContext(null);

export const InterestProvider = ({ children }) => {
    const [interest, setInterest] = useState(() => {
        return localStorage.getItem("selected_interest") || "";
    });

    useEffect(() => {
        if (interest) localStorage.setItem("selected_interest", interest);
    }, [interest]);

    return (
        <InterestContext.Provider value={{ interest, setInterest }}>
        {children}
        </InterestContext.Provider>
    );
};

export const useInterest = () => {
    const ctx = useContext(InterestContext);
    if (!ctx) throw new Error("useInterest must be used inside InterestProvider");
    return ctx;
};